import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { change, destroy, getFormValues } from 'redux-form';
import { withRouter } from 'react-router';
import { MenusNavMenu } from './components/MenusNavMenu';
import { Main, Filter } from 'Containers/';
import { Button, Grid, Checkbox } from 'semantic-ui-react';
import moment from 'moment';
import qs from 'qs';

import 'PageStyles/managemenu/index.less';
import { MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME } from 'Common/FormEnum';
import { CycleMenuDetailsFieldEnum as Fields } from 'Common/FieldEnum';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { resetDirty } from 'State/dirtyTracking/actions';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { LoadingBase, YesNoDialog } from 'Components/';

import {
  MENU_OPTION_CYCLE_MENU,
  NEW_MODIFIER,
  MENU_OPTION_CYCLE_MENU_NEW,
  MENU_OPTION_CALENDAR,
  MENU_OPTION_LIST_MENUS,
  MENU_OPTION_TEMPLATE_MENUS,
  MENU_OPTION_APPLIED_MENUS,
  EDIT_MENU_QUERYSTRINGS,
  EDIT_MENU_TYPES,
} from './helpers/Constants';
import { CycleMenuList } from './tabs/CycleMenuList';
import { CycleMenuDetailsForm } from './tabs/CycleMenuDetailsForm';
import { AppliedMenuList } from './tabs/AppliedMenuList';
import {
  getCyclesFromFilters,
  clearErrors,
  setSaveSuccessful,
  saveNewCycleMenu,
} from './state/listcycles/actions';
import * as Selector from './state/listcycles/selectors';
import { setEditing, setDuplicating } from './state/listcycles/actions';

class ManageMenuContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: MENU_OPTION_CYCLE_MENU,
      showInactive: false,
      showAddButton: true,
      showMenusNav: true,
      showConfirmDayChangeModal: false,
    };
    const { location } = props;

    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
    const view = Number(queryParams[EDIT_MENU_QUERYSTRINGS.VIEW]);

    if (view === EDIT_MENU_TYPES.APPLIED_MENU) {
      this.state.activeItem = MENU_OPTION_APPLIED_MENUS;
    }
  }

  componentDidUpdate(prevProps) {
    const { newCycleMenu: prevNewCycleMenu } = prevProps;
    const {
      saveSuccessful,
      newCycleMenu,
      history,
      setSaveSuccessful,
      resetDirty,
      clearErrors,
    } = this.props;
    if (errorToast(this.props, prevProps, 'fetchError')) {
      clearErrors();
    }

    if (saveSuccessful && saveSuccessful !== prevProps.saveSuccessful) {
      createToast(toastType.success, 'Success', 'Saved Successfully.', true);

      setSaveSuccessful(false);
      resetDirty();
    }

    // New cycle menu has been created so go to the edit cycle menu page
    if (prevNewCycleMenu !== newCycleMenu && newCycleMenu) {
      history.push(
        `/managemenu/edit/${newCycleMenu.id}?${EDIT_MENU_QUERYSTRINGS.VIEW}=${EDIT_MENU_TYPES.CYCLE_MENU}`
      );
    }
  }

  componentDidMount() {
    const { editing, editCycleValues, change } = this.props;

    this.loadMenuList();

    if (editing) {
      const {
        id,
        description,
        numberOfDays,
        nutritionStandardId,
        fiscalYear,
        servings,
        analysisDays,
      } = editCycleValues;

      this.setState(
        {
          activeItem: MENU_OPTION_CYCLE_MENU_NEW,
          showAddButton: false,
          showMenusNav: false,
        },
        () => {
          change(MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME, Fields.Id, id);
          change(
            MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME,
            Fields.Description,
            description
          );
          change(
            MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME,
            Fields.NumberOfDaysInCycle,
            numberOfDays
          );
          change(
            MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME,
            Fields.NutritionStandardId,
            nutritionStandardId
          );
          change(
            MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME,
            Fields.FiscalYear,
            fiscalYear
          );
          change(
            MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME,
            Fields.Servings,
            servings
          );
          change(
            MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME,
            Fields.AnalysisDays,
            analysisDays
          );
        }
      );
    }
  }

  loadMenuList = () => {
    this.props.getCyclesFromFilters({ isActive: !this.state.showInactive });
  };

  onMenuChange = (activeItem) => {
    this.setState({ activeItem });
  };

  onActiveChange = (value) => {
    const isActive = value && value.checked;

    const { activeItem } = this.state;
    switch (activeItem) {
      case MENU_OPTION_CYCLE_MENU:
        this.props.getCyclesFromFilters({ isActive: !isActive });
        this.setState({ showInactive: isActive });
        break;
      default:
        return;
    }
  };

  showAddButtonAndMenuNav = (show) => {
    this.setState({ showAddButton: show, showMenusNav: show });
  };

  renderPageContent = (activeItem) => {
    const { isReadOnly, sitesMap, editing } = this.props;
    const { showConfirmDayChangeModal } = this.state;

    switch (activeItem) {
      case MENU_OPTION_CYCLE_MENU:
        return (
          <CycleMenuList
            onMenuChange={this.onMenuChange}
            loadMenuList={this.loadMenuList}
            isReadOnly={isReadOnly}
            showAddButtonAndMenuNav={this.showAddButtonAndMenuNav}
          />
        );
      case MENU_OPTION_CYCLE_MENU_NEW:
        return (
          <Fragment>
            {showConfirmDayChangeModal && (
              <YesNoDialog
                showDialog={showConfirmDayChangeModal}
                title={'Reduce The Number Of Days On The Menu?'}
                question={
                  'Are you sure you want to reduce the number of days on this menu? Data from the days no longer on the menu will be deleted.'
                }
                yesCallback={() => {
                  this.handleConfirmYesNo(true);
                }}
                noCallback={() => {
                  this.handleConfirmYesNo(false);
                }}
              />
            )}
            <CycleMenuDetailsForm
              onSubmit={this.handleSubmitCycleMenu}
              initialValues={this.inititalValues}
              editing={editing}
            />
          </Fragment>
        );
      case MENU_OPTION_APPLIED_MENUS:
        return <AppliedMenuList sitesMap={sitesMap} isReadOnly={isReadOnly} />;
      case MENU_OPTION_CALENDAR:
        return null;
      default:
        return null;
    }
  };

  handleConfirmYesNo = (confirmed) => {
    if (!confirmed) {
      this.setState({ showConfirmDayChangeModal: false });
    } else {
      this.setState({ showConfirmDayChangeModal: false });
      this.submitCycleMenu();
    }
  };

  handleSubmitCycleMenu = (value) => {
    const { editing } = this.props;

    if (
      editing &&
      value[Fields.NumberOfDaysInCycle] <
        this.inititalValues[Fields.NumberOfDaysInCycle]
    ) {
      this.setState({ showConfirmDayChangeModal: true });
    } else {
      this.submitCycleMenu();
    }
  };

  submitCycleMenu = async () => {
    const {
      editing,
      saveNewCycleMenu,
      setEditing,
      duplicating,
      setDuplicating,
      formValues,
    } = this.props;

    const saved = await saveNewCycleMenu(formValues);
    // Set editing to false after the save otherwise the form values will default to the empty form state
    // due to the initial values being dependent on the editing flag
    if (editing && saved) {
      setEditing(false);
    }

    if (duplicating) {
      setDuplicating(false);
    }
  };

  addButtonTexts = {
    [MENU_OPTION_CYCLE_MENU]: 'Add Cycle Menu',
    [MENU_OPTION_CALENDAR]: 'Add Calendar',
    [MENU_OPTION_LIST_MENUS]: 'Add List Menus',
    [MENU_OPTION_TEMPLATE_MENUS]: 'Add Template Menus',
  };

  getAddButtonText = (activeItem) => {
    activeItem = activeItem.replace(NEW_MODIFIER, '');

    const foundInfo =
      this.addButtonInfo &&
      this.addButtonInfo.find((x) => x.name === activeItem);

    if (foundInfo) {
      return foundInfo.text;
    }
  };

  onBackClick = () => {
    const {
      editing,
      setEditing,
      resetDirty,
      duplicating,
      setDuplicating,
      destroy,
    } = this.props;

    if (editing) {
      setEditing(false);
      destroy(MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME);
    } else if (duplicating) {
      setDuplicating(false);
    } else {
      resetDirty();
    }
  };

  getMainProps = () => {
    const { isReadOnly, editing, editCycleValues } = this.props;

    return this.state.activeItem && this.state.activeItem.includes(NEW_MODIFIER)
      ? {
          toolbox: {
            formName: MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME,
            shown: true,
            isReadOnly: isReadOnly,
            backButtonProps: {
              shown: true,
              path: editing
                ? `/managemenu/edit/${editCycleValues.id}?${EDIT_MENU_QUERYSTRINGS.VIEW}=${EDIT_MENU_TYPES.CYCLE_MENU}`
                : '/managemenu',
              callback: this.onBackClick,
            },
            saveButtonProps: {
              content: 'Save Cycle Menu',
            },
          },
        }
      : null;
  };

  get inititalValues() {
    const { editing, editCycleValues, duplicating } = this.props;

    if (editing || duplicating) {
      const {
        id,
        description,
        numberOfDays,
        nutritionStandardId,
        fiscalYear,
        servings,
        analysisDays,
      } = editCycleValues;

      return {
        [Fields.Description]: description,
        [Fields.NumberOfDaysInCycle]: numberOfDays,
        [Fields.NutritionStandardId]: nutritionStandardId,
        [Fields.FiscalYear]: fiscalYear,
        [Fields.Servings]: servings,
        [Fields.AnalysisDays]: analysisDays,
        [Fields.Id]: id,
      };
    }

    return {
      [Fields.FiscalYear]: moment().year(),
      [Fields.Servings]: 100,
      [Fields.AnalysisDays]: 5,
    };
  }

  shouldShowInactive() {
    const { activeItem } = this.state;

    switch (activeItem) {
      case MENU_OPTION_APPLIED_MENUS:
      case MENU_OPTION_CALENDAR:
        return false;
      default:
        return !activeItem.includes(NEW_MODIFIER);
    }
  }

  renderAddButton() {
    const { isReadOnly } = this.props;
    const { showAddButton, activeItem } = this.state;

    if (!isReadOnly && showAddButton && this.addButtonTexts[activeItem]) {
      return (
        <Grid.Column width={6} floated="right">
          <Button
            fluid
            onClick={() =>
              this.setState({
                activeItem: activeItem + NEW_MODIFIER,
                showAddButton: false,
                showMenusNav: false,
              })
            }
          >
            {this.addButtonTexts[activeItem]}
          </Button>
        </Grid.Column>
      );
    }
    return null;
  }

  render() {
    const { activeItem, showMenusNav } = this.state;
    const { duplicateFetching, fetching } = this.props;

    if (duplicateFetching) {
      return <LoadingBase />;
    }

    return (
      <Fragment>
        <Filter title="Manage Menus">
          <Grid textAlign="right">
            <Grid.Row textAlign="right">
              <Grid.Column width={4} floated="right" className="menus-filter">
                {this.shouldShowInactive() && (
                  <Checkbox
                    label="Show Inactive"
                    toggle
                    onChange={(e, data) => this.onActiveChange(data)}
                    checked={this.state.showInactive}
                  />
                )}
              </Grid.Column>
              {this.renderAddButton()}
            </Grid.Row>
          </Grid>
        </Filter>
        <Main {...this.getMainProps()}>
          {showMenusNav && (
            <MenusNavMenu
              activeItem={activeItem || MENU_OPTION_CYCLE_MENU}
              onMenuChange={this.onMenuChange}
              resetDirty={this.props.resetDirty}
            />
          )}
          {fetching && <LoadingBase />}
          {this.renderPageContent(activeItem)}
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(
    getIsDirty(MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME)(state)
  );

  return {
    fetchError: Selector.getFetchError(state),
    saveSuccessful: Selector.getSaveSuccessful(state),
    newCycleMenu: Selector.getNewCycleMenu(state),
    editing: Selector.getEditing(state),
    editCycleValues: Selector.getEditCycleValues(state),
    duplicating: Selector.getDuplicating(state),
    duplicateFetching: Selector.getDuplicateFetching(state),
    formValues: getFormValues(MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME)(state),
    fetching: Selector.getFetching(state),
  };
};
const mapDispatchToProps = {
  getCyclesFromFilters,
  clearErrors,
  setSaveSuccessful,
  saveNewCycleMenu,
  resetDirty,
  setEditing,
  setDuplicating,
  change,
  getFormValues,
  destroy,
};

export const ManageMenu = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageMenuContainer)
);



// WEBPACK FOOTER //
// ./src/pages/managemenu/ManageMenu.js